"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thumbnail = exports.sha1 = exports.tipjar = exports.PersonalProfileDocument = exports.accountServiceHomepage = exports.accountName = exports.OnlineAccount = exports.account = exports.pastProject = exports.currentProject = exports.publications = exports.schoolHomepage = exports.workInfoHomepage = exports.workplaceHomepage = exports.page = exports.topic = exports.topic_interest = exports.interest = exports.mbox_sha1sum = exports.jabberID = exports.openid = exports.weblog = exports.homepage = exports.mbox = exports.nick = exports.Image = exports.Document = exports.member = exports.Group = exports.Organization = exports.Project = exports.primaryTopicOf = exports.primaryTopic = exports.maker = exports.made = exports.age = exports.based_near = exports.knows = exports.givenName = exports.familyName = exports.depicts = exports.depiction = exports.img = exports.title = exports.name = exports.Person = exports.Agent = exports._self = exports.ns = exports.loadData = void 0;
exports.foaf = exports.logo = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//finally, we pass on all the exports, plus the namespace, prefix and data loading function
// as we register this ontology in the LINCD tree
const _this = __importStar(require("./foaf"));
var loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/foaf.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
exports.ns = (0, NameSpace_1.createNameSpace)('http://xmlns.com/foaf/0.1/');
//It's recommended to export a NamedNode for the ontology itself as well
exports._self = (0, exports.ns)('');
//The main goal though of this file is to export a reference to NamedNode with the correct URI
// for all the entities (Classes and properties) in the ontology
exports.Agent = (0, exports.ns)('Agent');
exports.Person = (0, exports.ns)('Person');
exports.name = (0, exports.ns)('name');
exports.title = (0, exports.ns)('title');
exports.img = (0, exports.ns)('img');
exports.depiction = (0, exports.ns)('depiction');
exports.depicts = (0, exports.ns)('depicts');
exports.familyName = (0, exports.ns)('familyName');
exports.givenName = (0, exports.ns)('givenName');
exports.knows = (0, exports.ns)('knows');
exports.based_near = (0, exports.ns)('based_near');
exports.age = (0, exports.ns)('age');
exports.made = (0, exports.ns)('made');
exports.maker = (0, exports.ns)('maker');
exports.primaryTopic = (0, exports.ns)('primaryTopic');
exports.primaryTopicOf = (0, exports.ns)('primaryTopicOf');
exports.Project = (0, exports.ns)('Project');
exports.Organization = (0, exports.ns)('Organization');
exports.Group = (0, exports.ns)('Group');
exports.member = (0, exports.ns)('member');
exports.Document = (0, exports.ns)('Document');
exports.Image = (0, exports.ns)('Image');
exports.nick = (0, exports.ns)('nick');
exports.mbox = (0, exports.ns)('mbox');
exports.homepage = (0, exports.ns)('homepage');
exports.weblog = (0, exports.ns)('weblog');
exports.openid = (0, exports.ns)('openid');
exports.jabberID = (0, exports.ns)('jabberID');
exports.mbox_sha1sum = (0, exports.ns)('mbox_sha1sum');
exports.interest = (0, exports.ns)('interest');
exports.topic_interest = (0, exports.ns)('topic_interest');
exports.topic = (0, exports.ns)('topic');
exports.page = (0, exports.ns)('page');
exports.workplaceHomepage = (0, exports.ns)('workplaceHomepage');
exports.workInfoHomepage = (0, exports.ns)('workInfoHomepage');
exports.schoolHomepage = (0, exports.ns)('schoolHomepage');
exports.publications = (0, exports.ns)('publications');
exports.currentProject = (0, exports.ns)('currentProject');
exports.pastProject = (0, exports.ns)('pastProject');
exports.account = (0, exports.ns)('account');
exports.OnlineAccount = (0, exports.ns)('OnlineAccount');
exports.accountName = (0, exports.ns)('accountName');
exports.accountServiceHomepage = (0, exports.ns)('accountServiceHomepage');
exports.PersonalProfileDocument = (0, exports.ns)('PersonalProfileDocument');
exports.tipjar = (0, exports.ns)('tipjar');
exports.sha1 = (0, exports.ns)('sha1');
exports.thumbnail = (0, exports.ns)('thumbnail');
exports.logo = (0, exports.ns)('logo');
exports.foaf = {
    Agent: exports.Agent,
    Person: exports.Person,
    name: exports.name,
    title: exports.title,
    img: exports.img,
    depiction: exports.depiction,
    depicts: exports.depicts,
    familyName: exports.familyName,
    givenName: exports.givenName,
    knows: exports.knows,
    based_near: exports.based_near,
    age: exports.age,
    made: exports.made,
    maker: exports.maker,
    primaryTopic: exports.primaryTopic,
    primaryTopicOf: exports.primaryTopicOf,
    Project: exports.Project,
    Organization: exports.Organization,
    Group: exports.Group,
    member: exports.member,
    Document: exports.Document,
    Image: exports.Image,
    nick: exports.nick,
    mbox: exports.mbox,
    homepage: exports.homepage,
    weblog: exports.weblog,
    openid: exports.openid,
    jabberID: exports.jabberID,
    mbox_sha1sum: exports.mbox_sha1sum,
    interest: exports.interest,
    topic_interest: exports.topic_interest,
    topic: exports.topic,
    page: exports.page,
    workplaceHomepage: exports.workplaceHomepage,
    workInfoHomepage: exports.workInfoHomepage,
    schoolHomepage: exports.schoolHomepage,
    publications: exports.publications,
    currentProject: exports.currentProject,
    pastProject: exports.pastProject,
    account: exports.account,
    OnlineAccount: exports.OnlineAccount,
    accountName: exports.accountName,
    accountServiceHomepage: exports.accountServiceHomepage,
    PersonalProfileDocument: exports.PersonalProfileDocument,
    tipjar: exports.tipjar,
    sha1: exports.sha1,
    thumbnail: exports.thumbnail,
    logo: exports.logo,
};
//as third parameter, provide a prefix (string) that can be used to refer to the full ontology URL.
//for foaf: 'schema' refers to https://www.schema.org/
(0, package_1.linkedOntology)(_this, exports.ns, 'foaf', exports.loadData, '../data/foaf.json');
//# sourceMappingURL=foaf.js.map